import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    systemMessageContainer: css({
        boxSizing: "border-box",
        padding: 24,
        width: "100%",
        height: 435,
        backgroundColor: Color.neutral[400],
    }),
    systemMessageListContainer: css({
        maxHeight: "calc(100% - 48px)",
        marginTop: "24px",
        overflowY: "scroll"
    }),
    systemMessageList: css({
        width: "100%",
        display: "inline-flex",
        alignItems: "center",
        height: 65,
        transition: "all .2s ease-in-out",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: Color.neutral[500]
        }
    }),
    systemMessageHeaderContainer: css({
        display: "flex",
        justifyContent: "space-between"
    })
});
